// extracted by mini-css-extract-plugin
export default {"supported":"NumberHelper_supported__lvqYm"};